import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import App from './App';
import ShiftHandoffForm from './components/ShiftHandoffForm';
import ShiftHistory from './components/ShiftHistory';
import ShiftDashboard from './components/ShiftDashboard';
import ChangeCalendar from './components/ChangeCalendar';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <ShiftHandoffForm />,
      },
      {
        path: 'history',
        element: <ShiftHistory />,
      },
      {
        path: 'history/:id',
        element: <ShiftHistory />,
      },
      {
        path: 'dashboard',
        element: <ShiftDashboard />,
      },
      {
        path: 'calendar',
        element: <ChangeCalendar />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export const AppRouter = () => <RouterProvider router={router} />;
